import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2/dist/sweetalert2.js'; 
import { DiscountTemplatesService } from '../discount-templates.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-discount-template',
  templateUrl: './create-discount-template.component.html',
  styleUrls: ['./create-discount-template.component.scss']
})
export class CreateDiscountTemplateComponent {
  errors: string[] | null = null;
  eventForm:FormGroup
  
  constructor(private fb: FormBuilder,public activeModal: NgbActiveModal,
    public discountService:DiscountTemplatesService,private toastr:ToastrService) {}

  ngOnInit(){
    this.eventForm = this.fb.group({
      Name: ['', [Validators.required, Validators.maxLength(100)]],
    });
  }
  onSubmit() {
    console.log(this.eventForm.valid)
    if (!this.eventForm.valid) return this.eventForm.markAllAsTouched();

    this.eventForm=this.fb.group({
      Name: this.eventForm.value.Name,
      IsActive:true
    })
    console.log(this.eventForm.value)
   this.discountService.CreateDiscountTemplate(this.eventForm.value)
   .subscribe({
    next: r=>{
      // Swal.fire('Created', '', 'success')
      this.toastr.success('Created','Success')
      this.activeModal.close({ refresh: true });
    },
    // error: e => this.errors = e.error?.errors || [e.error?.message]
    error: e => {
      if (e.error?.errors || [e.error?.message]) {
        this.toastr.error('Oops!', e.error.message);
      }
      else {
        this.toastr.error('Oops!', "Something went wrong");
      }
    }
   })
   
  }

}
